module.exports = __webpack_public_path__ + "static/media/penguinFashion.f0295cee.png";